module.exports = __webpack_public_path__ + "img/viewhist.9a74804a.svg";